import { render, staticRenderFns } from "./financeiro-especialidade.vue?vue&type=template&id=3fbcbf2f&scoped=true"
import script from "./financeiro-especialidade.vue?vue&type=script&lang=ts"
export * from "./financeiro-especialidade.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-especialidade.vue?vue&type=style&index=0&id=3fbcbf2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbcbf2f",
  null
  
)

export default component.exports